export const parseMathML = (renderedNode) => {
  if (renderedNode) {
    // eslint-disable-next-line no-unused-expressions
    window.com?.wiris?.js?.JsPluginViewer?.parseElement(renderedNode, true)
  }
}
